import React from "react";

//styling
import "./clusterRow.css";

//material ui
import Typography from "@material-ui/core/Typography";
import AlarmIcon from "@material-ui/icons/Alarm";

//for formatting date
import moment from "moment";

const ClusterRowMobileInfoHTMLContentBottom = ({
  clusterInfo,
  isDataSet,
  classes,
}) => {
  return (
    <>
      <div className={classes.content}>
        <div className={classes.labelDiv}>
          <AlarmIcon />
          <label className={classes.label}>Expiration</label>
        </div>
        <Typography className={classes.text}>
          {moment(clusterInfo.data.status.endTime).format(
            "ddd, MM/DD/YY, h:mm a"
          )}
        </Typography>
      </div>
    </>
  );
};

export default ClusterRowMobileInfoHTMLContentBottom;
